const navigation = {
	closeButton: document.getElementById('navClose'),
	openButton: document.getElementById('navToggle'),
	menu: document.getElementById('mainNav'),

	init: function() {
		this.closeButton.addEventListener('click', () => {
			navigation.menu.hidden = true;
			navigation.menu.setAttribute('aria-hidden', true);
		})

		this.openButton.addEventListener('click', () => {
			navigation.menu.hidden = false;
			navigation.menu.setAttribute('aria-hidden', false);
		})
	}
}

export default navigation;